import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import AuthGuard from './components/AuthGuard';
import Layout from './components/Layout/Layout';
import { RBACProvider } from './contexts/RBACContext';
import { EnvironmentProvider } from './contexts/EnvironmentContext';
import { NotificationProvider } from './contexts/NotificationContext';
import RoleGate from './components/permissions/RoleGate';
import { ProtectedRoute } from './components/permissions/ProtectedRoute';
import { APP_ROUTES, AppRoute } from './routes/appRoutes';

/** Élément de route : l'écran, sous `ProtectedRoute` s'il exige un rôle. */
const routeElement = ({ element, roles }: AppRoute) =>
  roles ? <ProtectedRoute roles={roles}>{element}</ProtectedRoute> : element;

/**
 * Console back-office : fournisseurs (environnement de l'onglet, session,
 * rôles, notifications), coquille et table des routes (`routes/appRoutes`).
 */
const App: React.FC = () => {
  return (
    <EnvironmentProvider>
    <AuthGuard>
      <RBACProvider>
      <NotificationProvider>
        <Layout>
          <RoleGate>
          <Routes>
            {APP_ROUTES.map((route) => (
              <Route key={route.path} path={route.path} element={routeElement(route)} />
            ))}

            {/* 404 Page */}
            <Route path="*" element={
              <Box textAlign="center" mt={4}>
                <h2>Page non trouvée</h2>
                <p>La page que vous recherchez n'existe pas.</p>
              </Box>
            } />
          </Routes>
          </RoleGate>
        </Layout>
      </NotificationProvider>
      </RBACProvider>
    </AuthGuard>
    </EnvironmentProvider>
  );
};

export default App;